import HttpService from "../baseService";

class AuthServiceProvider extends HttpService {
	constructor() {
		super("authenticate");
	}

	/**
	 * Login a user by username and password
	 *
	 * @param {Account.Login} data
	 * @async
	 * @version 1.0.0
	 */
	public login(data: Account.Login): HttpService.Login {
		return this.dynamicMakeResource("authenticate", "v2").post("web-login", data);
	}

	/**
	 * Confirm login a user by username and password
	 *
	 * @param {Account.LoginConfirm} data
	 * @async
	 * @version 1.0.0
	 */
	public loginConfirm(data: Account.LoginConfirm): HttpService.LoginConfirm {
		return this.getResource().post("web-login-confirm", data);
	}

	/**
	 * Login a user by aan payload
	 *
	 * @param {Account.AanLogin} data
	 * @async
	 * @version 1.0.0
	 */
	public aanLogin(data: Account.AanLogin): HttpService.AanLogin {
		return this.getResource().post("aan-login", data);
	}

	/**
	 * Check User Exist
	 *
	 * @param mobileNumber
	 * @async
	 * @version 1.0.0
	 */
	public isUserExist(mobileNumber: string): HttpService.BaseResponse {
		return this.getResource().get(`is-exist/${mobileNumber}`);
	}

	/**
	 * Register a user
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public register(data: Account.User): HttpService.Register {
		return this.getResource().post("register/init-password", data);
	}

	/**
	 * Register a user
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public registerByEmail(data: Account.User): HttpService.Register {
		return this.getResource().post("email-register/init", data);
	}

	/**
	 * Register a user
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public finishRegisterByEmail(data: any): HttpService.Register {
		return this.getResource().post("email-register/finish", data);
	}

	/**
	 * Verify the email activation code which is it true or not
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public verifyEmailActivationCode(code?: string): HttpService.CheckCode {
		return this.getResource().get(`email-register/check-code/?code=${code}`);
	}

	/**
	 * Verify the activation code which is it true or not
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public verifyActivationCode(data: Account.VerifyActivationCode): HttpService.CheckCode {
		return this.getResource().post("register/check-code", data);
	}

	/**
	 * Initialize reset password: get mobile number
	 *
	 * @param mobileNumber
	 * @async
	 * @version 1.0.0
	 */
	public initResetPassword(mobileNumber: string): HttpService.InitResetPassword {
		return this.getResource().get(`reset-password/init/${mobileNumber}`);
	}

	/**
	 * Reset password: get strategy
	 *
	 * @param mobileNumber
	 * @async
	 * @version 1.0.0
	 */
	public getStrategy(mobileNumber: string, code: string): HttpService.ResetPasswordStrategy {
		return this.getResource().post(`reset-password/get-strategy/${mobileNumber}`, code);
	}

	/**
	 * Reset password: get question
	 *
	 * @param mobileNumber
	 * @async
	 * @version 1.0.0
	 */
	public getQuestion(mobileNumber: string, code: string): HttpService.ResetPasswordQuestion {
		return this.getResource().get(`reset-password/get-question/${mobileNumber}?code=${code}`);
	}

	/**
	 * Reset password: answer question
	 *
	 * @param mobileNumber
	 * @async
	 * @version 1.0.0
	 */
	public answerQuestion(mobileNumber: string, code: string, answer: string): HttpService.ResetPasswordQuestion {
		return this.getResource().post(`reset-password/answer-question/${mobileNumber}/${code}`, answer);
	}

	/**
	 * Change user password
	 *
	 * @async
	 * @version 1.0.0
	 * @param data
	 */
	public finishForgetPassword(data: Account.ForgetPassword): HttpService.FinishResetPassword {
		return this.getResource().post("reset-password/finish", data);
	}

	/**
	 * resend verification code
	 *
	 * @async
	 * @version 1.0.0
	 * @param mobileNumber
	 */
	public sendActivationCode(mobileNumber: string): HttpService.BaseResponse {
		return this.getResource().get(`is-exist/${mobileNumber}`);
	}
}

const AuthService = new AuthServiceProvider();

export default AuthService;
